/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Nickname_InvalidInputs */

const en_us2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a nickname of up to 30 characters.`)
};

const pt_br2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um apelido de até 30 letras.`)
};

const es_419_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un apodo de hasta 30 caracteres.`)
};

const pt_pt2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe uma alcunha com até 30 caracteres.`)
};

const fr_fr2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis un pseudo de 30 caractères maximum.`)
};

const de_de2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen Spitznamen mit bis zu 30 Zeichen.`)
};

const it_it2_club_nickname_invalid = /** @type {(inputs: Club_Nickname_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un soprannome di massimo 30 caratteri.`)
};

/**
* | output |
* | --- |
* | "Choose a nickname of up to 30 characters." |
*
* @param {Club_Nickname_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_nickname_invalid = /** @type {((inputs?: Club_Nickname_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Nickname_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_nickname_invalid(inputs)
	if (locale === "es-419") return es_419_club_nickname_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_club_nickname_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_club_nickname_invalid(inputs)
	if (locale === "de-DE") return de_de2_club_nickname_invalid(inputs)
	if (locale === "it-IT") return it_it2_club_nickname_invalid(inputs)
	return en_us2_club_nickname_invalid(inputs)
});
export { club_nickname_invalid as "club.nickname_invalid" }